// extracted by mini-css-extract-plugin
export default {"ordersButton":"styles_ordersButton__7fTsQ","buttonsContainer":"styles_buttonsContainer__shwPl"};